import React from 'react';

import Section from '../Section';

const Impact = () => (
  <Section title="Impact" shade={4}>
    <p>
      The ongoing development of the design system at New Engen has resulted in:
    </p>
    <ul>
      <li>
        New Storybook library open to engineers, designers, and product managers
      </li>
      <li>
        A single source of truth with documented designs and guidelines for
        their uses
      </li>
      <li>
        A Figma library used to efficiently craft cohesive high-fidelity designs
      </li>
      <li>
        Cross-functional team of designers and engineers that are excited about
        creating high quality experiences
      </li>
      <li>
        Increasingly collaborative approach between design & engineering as a
        result of the project
      </li>
      <li>
        UX team spending more time on the overall user experience and user
        interactions instead of focusing efforts on UI design.
      </li>
    </ul>
    <blockquote>
      "Matt was instrumental in updating our UX Design System into a tool that
      allowed for better collaboration and interaction for the UX Team. He was
      proactive in making sure that our components, styles and patterns were
      always documented and up-to-date with industry standards. Matt also worked
      closely with the engineering team to ensure the system was properly built
      out, which was crucial for the successful implementation into our
      production environment." <br />
      <br />- Jason Bourguignon, Director of Design at New Engen
    </blockquote>
  </Section>
);

export default Impact;



// WEBPACK FOOTER //
// ./src/components/new-engen-design-system/Impact.js